import { get, post, patch } from './fetcher';

const GEUPJI = '/api/admin/geupji';

// ===== 지역 셀렉트 =====
export const getSido = async (token) => {
  const res = await get(`${GEUPJI}/sido`, {}, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '시도 조회에 실패했습니다.');
};

export const getSigungu = async (token, sido) => {
  const res = await get(`${GEUPJI}/sigungu`, { sido }, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '시군구 조회에 실패했습니다.');
};

export const getDong = async (token, sigungu) => {
  const res = await get(`${GEUPJI}/dong`, { sigungu }, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '읍면동 조회에 실패했습니다.');
};

// ===== 조회 =====
export const queryRegion = async (token, bjd, { speculation = false, regulation = false } = {}) => {
  const res = await get(`${GEUPJI}/region`, {
    bjd: bjd || '',
    speculation: speculation ? 'true' : undefined,
    regulation: regulation ? 'true' : undefined,
  }, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '지역 데이터 조회에 실패했습니다.');
};

export const queryMaster = async (token) => {
  const res = await get(`${GEUPJI}/master`, {}, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '급지마스터 조회에 실패했습니다.');
};

export const regionExists = async (token, bjd) => {
  const res = await get(`${GEUPJI}/region/exists`, { bjd: bjd || '' }, token);
  return { ok: !!res?.success, exists: !!res?.data?.exists, message: res?.message };
};

// ===== 지역 행 추가 =====
export const addRegionRow = async (token, bjdCode, overwrite = false) => {
  const res = await post(`${GEUPJI}/region`, { bjdCode, overwrite }, token);
  return { ok: !!res?.success, exists: !!res?.data?.exists, affected: res?.data?.affected || 0, message: res?.message };
};

// ===== 셀 즉시 저장 =====
export const updateRegionCell = async (token, { bjdCode, field, value }) => {
  const res = await patch(`${GEUPJI}/region`, { bjdCode, field, value }, token);
  return { ok: !!res?.success, message: res?.message };
};

export const updateMasterCell = async (token, { baseDate, oldPyeongPrice, newPyeongPrice, geupji }) => {
  const res = await patch(`${GEUPJI}/master`, { baseDate, oldPyeongPrice, newPyeongPrice, geupji }, token);
  return { ok: !!res?.success, newPyeongPrice: res?.data?.newPyeongPrice, newGeupji: res?.data?.newGeupji, message: res?.message };
};

// ===== 지정 목록 =====
export const getSpeculationList = async (token) => {
  const res = await get(`${GEUPJI}/speculation/list`, {}, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '투기과열 목록 조회에 실패했습니다.');
};

export const getRegulationList = async (token) => {
  const res = await get(`${GEUPJI}/regulation/list`, {}, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '규제 목록 조회에 실패했습니다.');
};

// ===== 지정 =====
export const designateSpeculation = async (token, { bjdCode, value }) => {
  const res = await post(`${GEUPJI}/designate/speculation`, { bjdCode, value }, token);
  return { ok: !!res?.success, affected: res?.data?.affected || 0, message: res?.message };
};

export const designateRegulation = async (token, { bjdCode, regulation, regulationDate }) => {
  const res = await post(`${GEUPJI}/designate/regulation`, { bjdCode, regulation, regulationDate }, token);
  return { ok: !!res?.success, affected: res?.data?.affected || 0, message: res?.message };
};
